// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3RM9F","title":"InfoRow_title__pgyWM"};